var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "value": _vm.show,
      "max-width": "500",
      "persistent": ""
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      }
    }
  }, [_c('v-card', {
    staticClass: "confirmation-dialog",
    attrs: {
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "confirmation-header"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "white"
    }
  }, [_vm._v("mdi-alert-circle")]), _c('span', {
    staticClass: "confirmation-title"
  }, [_vm._v(_vm._s(_vm.title || 'Confirm Action'))])], 1), _c('v-card-text', {
    staticClass: "confirmation-content"
  }, [_c('p', {
    staticClass: "confirmation-message"
  }, [_vm._v(_vm._s(_vm.message))])]), _c('v-card-actions', {
    staticClass: "confirmation-actions"
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "confirmation-btn",
    attrs: {
      "outlined": "",
      "color": "grey",
      "dark": ""
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(" Cancel ")]), _c('v-btn', {
    staticClass: "confirmation-btn",
    attrs: {
      "color": "primary",
      "dark": "",
      "elevation": "2"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-check")]), _vm._v(" Confirm ")], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }